import React from 'react'
import { useSearchParams } from 'react-router-dom';
import { useSlider } from '../../hooks/useSlider';
// import Gobernator from '../Gobernator';
import './Tab.scss';

const TabGobernator = ({estados, toggleTab, toggleState}) => {
  const marginSize = 9;
  const {
    refContainer,
    refSlider,
    moveLeft,
    moveRight,
    isActive,
    leftStatus,
    rightStatus,
  }= useSlider({ margin: marginSize })

  /** URL Params*/
  const [searchParams] = useSearchParams();
  const theme = searchParams.get('theme') || ''

  // const estados = [
  //   { id: 1, nombre: "Aguascalientes", url: "https://data-ecp.infobae.com/infobae.com/2022/méxico/locales/MX-AGU_governors.json" },
  //   { id: 2, nombre: "Durango", url: "https://data-ecp.infobae.com/infobae.com/2022/méxico/locales/MX-DUR_governors.json" },
  //   { id: 3, nombre: "Hidalgo", url: "https://data-ecp.infobae.com/infobae.com/2022/méxico/locales/MX-HID_governors.json" },
  //   { id: 4, nombre: "Oaxaca", url: "https://data-ecp.infobae.com/infobae.com/2022/méxico/locales/MX-OAX_governors.json" },
  //   { id: 5, nombre: "Quintana Roo", url: "https://data-ecp.infobae.com/infobae.com/2022/méxico/locales/MX-ROO_governors.json" },
  //   { id: 6, nombre: "Tamaulipas", url: "https://data-ecp.infobae.com/infobae.com/2022/méxico/locales/MX-TAM_governors.json" },
  // ]

  // const [toggleState, setToggleState] = useState(1);

  // const toggleTab = (index) => {
  //   setToggleState(index);
  // };

  // const currentUrl = estados[toggleState-1].url || "valor por defecto";
  const currentEstado = estados[toggleState];
  
  return (
    <div className={ theme === 'dark' ? 'tab-container dark' : 'tab-container'}>
    <div className="tab-container__header">
      {
        isActive && <button onClick={moveLeft}
          className={`slider-container__right-left ${!leftStatus && 'desactive'}`}
        ></button>
      }
      <div className="slider-container" ref={refContainer}>
        <div className="tab-container__estados" ref={refSlider}>
          {estados.map((estado, i) => (
            <div key={estado.id} className="div-tab">
              <button
                className={ estado.id === currentEstado.id ? "tabs active-tabs" : "tabs"}
                onClick={() => toggleTab(i)}
              >
                {estado.state}
              </button>
            </div>
          ))}
        </div>
      </div>
      {
        isActive && <button onClick={moveRight}
          className={`slider-container__right ${!rightStatus && 'desactive'}`}
        ></button>
      }
    </div>
  </div>
  )
}

export default TabGobernator;
